var map = {
	"./BFBB.webp": 93711,
	"./Balatro.png": 28919,
	"./Banjo-Tooie.png": 29413,
	"./CC.png": 87968,
	"./ChecksMate.png": 64334,
	"./CloneHero.svg": 70565,
	"./Clone_Hero.png": 81528,
	"./Cookie_Clicker.png": 62584,
	"./DSR.webp": 90672,
	"./Golf.png": 458,
	"./Golf_with_your_Friends.png": 5287,
	"./Hades.png": 52747,
	"./Hunie_Pop_2.png": 1484,
	"./MC.png": 84370,
	"./MK64.webp": 31213,
	"./Mario_Kart_64.webp": 20315,
	"./Metin2.png": 73553,
	"./Minecraft.png": 13061,
	"./OC2.png": 38988,
	"./Overcooked.png": 93871,
	"./PKMN.png": 11972,
	"./PKMN_CRYSTAL.webp": 35600,
	"./PKMN_Emerald.webp": 52578,
	"./Pokemon_Crystal.webp": 27613,
	"./Pokemon_Emerald.webp": 50847,
	"./SM64.webp": 18233,
	"./SMW.png": 27587,
	"./Sims.svg": 79022,
	"./Software_Inc.png": 6308,
	"./Specter.png": 14038,
	"./Spectre.png": 19648,
	"./Super_Mario_64.webp": 740,
	"./Super_Mario_World.png": 9301,
	"./Yacht.svg": 14907,
	"./Yacht_Dice.svg": 28123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37378;